// extracted by mini-css-extract-plugin
module.exports = {"container":"thxnotification_container__i-jEv","icon":"thxnotification_icon__1HTkE","title":"thxnotification_title__32ICa","text":"thxnotification_text__1XYIp"};